import logo from './logo.svg';
import './App.css';
import demo from './demo.avif';

function App() {
  return (<>
    <div className='page'>
      <div className='card main-store'>

        <div className='title-bar'>
          <span className='title'>[-] <span className='red'>T</span>rusted <span className='red'>V</span>endor</span>
          <div className='flex-centered-title'>
            <span className='pulse-text'>WELCOME TO THE CHEAPEST VALORANT ACCOUNTS MARKET IN THE WORLD! OFFERING DAILY SUPPORT IN DISCORD!</span>
          </div>
        </div>

        <div className='brag'>
          <span className='brag-title'>Highest Quality Accounts for the Cheapest Price!</span>
          <div className='contact-buttons'>
            <button className='btn-primary'>Discord</button>
            <button className='btn-primary'>Telegram</button>
          </div>
          <div className='brag-stats'>
            <div className=''>74.3K+ products sold</div>
            <div className=''>22.1K+ customers</div>
            <div className=''>2K+ tickets solved</div>
            <div className=''>2023 launched</div>
          </div>
        </div>

        <div className='featured'>
          <span className='featured-title'>Products</span>
          <div className='product-row'>

            <div className='product'>
              <img className='product-image' src={demo}></img>
              <span className='product-title'>EU Skinned</span>
              <span className='product-desc'>Fully Randomized 50% Inactive, 50% Active Skinned Accounts Ranging from 1 to 500 skins</span>
              <button className='product-button'>View</button>
            </div>

            <div className='product'>
              <img className='product-image' src={demo}></img>
              <span className='product-title'>EU Skinned</span>
              <span className='product-desc'>Fully Randomized 50% Inactive, 50% Active Skinned Accounts Ranging from 1 to 500 skins</span>
              <button className='product-button'>View</button>
            </div>

            <div className='product'>
              <img className='product-image' src={demo}></img>
              <span className='product-title'>EU Skinned</span>
              <span className='product-desc'>Fully Randomized 50% Inactive, 50% Active Skinned Accounts Ranging from 1 to 500 skins</span>
              <button className='product-button'>View</button>
            </div>

            <div className='product'>
              <img className='product-image' src={demo}></img>
              <span className='product-title'>EU Skinned</span>
              <span className='product-desc'>Fully Randomized 50% Inactive, 50% Active Skinned Accounts Ranging from 1 to 500 skins</span>
              <button className='product-button'>View</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>);
}

export default App;
